export default {
  Machine: "/",
  Communications: "/communications",
  ThankYou: "/thankyou",
};
